import { render, staticRenderFns } from "./Crisis_Intervent.vue?vue&type=template&id=98dfe432"
import script from "./Crisis_Intervent.vue?vue&type=script&lang=js"
export * from "./Crisis_Intervent.vue?vue&type=script&lang=js"
import style0 from "./Crisis_Intervent.vue?vue&type=style&index=0&id=98dfe432&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports